import { Injectable, EventEmitter, Output } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import'rxjs/add/operator/map';
import'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { AuthConfiguration } from '../modules/auth.configuration';
import { OidcSecurityValidation } from './oidc.security.validation';
import { OidcSecurityCheckSession } from './oidc.security.check-session';
import { OidcSecuritySilentRenew } from './oidc.security.silent-renew';
import { OidcSecurityUserService } from './oidc.security.user-service';
import { OidcSecurityCommon } from './oidc.security.common';
import { AuthWellKnownEndpoints } from './auth.well-known-endpoints';

import { JwtKeys } from './jwtkeys';
export class OidcSecurityService {

     onUserDataLoaded: EventEmitter<any> = new EventEmitter<any>(true);

    checkSessionChanged: boolean;
    isAuthorized: boolean;
private headers: Headers;
private oidcSecurityValidation: OidcSecurityValidation;
private errorMessage: string;
private jwtKeys: JwtKeys;
/**
 * @param {?} http
 * @param {?} authConfiguration
 * @param {?} router
 * @param {?} oidcSecurityCheckSession
 * @param {?} oidcSecuritySilentRenew
 * @param {?} oidcSecurityUserService
 * @param {?} oidcSecurityCommon
 * @param {?} authWellKnownEndpoints
 */
constructor(
private http: Http,
private authConfiguration: AuthConfiguration,
private router: Router,
private oidcSecurityCheckSession: OidcSecurityCheckSession,
private oidcSecuritySilentRenew: OidcSecuritySilentRenew,
private oidcSecurityUserService: OidcSecurityUserService,
private oidcSecurityCommon: OidcSecurityCommon,
private authWellKnownEndpoints: AuthWellKnownEndpoints
    ) {
        this.oidcSecurityValidation = new OidcSecurityValidation(this.oidcSecurityCommon);

        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        if (this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_is_authorized) !== '') {
            this.isAuthorized = this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_is_authorized);
        }

        this.oidcSecurityCheckSession.onCheckSessionChanged.subscribe(() => { this.onCheckSessionChanged(); });
    }
/**
 * @return {?}
 */
getToken(): any {
        return this.oidcSecurityCommon.getAccessToken();
    }
/**
 * @return {?}
 */
getUserData(): any {
        if (!this.isAuthorized) {
            this.oidcSecurityCommon.logError('User must be logged in before you can get the user data!')
        }

        return this.oidcSecurityUserService.userData;
    }
/**
 * @return {?}
 */
authorize() {

        if (!this.oidcSecurityValidation.config_validate_response_type(this.authConfiguration.response_type)) {
            // invalid response_type
            return
        }

        this.resetAuthorizationData();

        this.oidcSecurityCommon.logDebug('BEGIN Authorize, no auth data');

        let /** @type {?} */ nonce = 'N' + Math.random() + '' + Date.now();
        let /** @type {?} */ state = Date.now() + '' + Math.random();

        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_auth_state_control, state);
        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_auth_nonce, nonce);
        this.oidcSecurityCommon.logDebug('AuthorizedController created. local state: ' + this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_auth_state_control));

        let /** @type {?} */ url = this.createAuthorizeUrl(nonce, state);
        window.location.href = url;
    }
/**
 * @return {?}
 */
authorizedCallback() {
        this.oidcSecurityCommon.logDebug('BEGIN authorizedCallback, no auth data');
        this.resetAuthorizationData();

        let /** @type {?} */ hash = window.location.hash.substr(1);

        let /** @type {?} */ result: any = hash.split('&').reduce(function (result: any, item: string) {
            let /** @type {?} */ parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
        }, {});

        this.oidcSecurityCommon.logDebug(result);
        this.oidcSecurityCommon.logDebug('authorizedCallback created, begin token validation');

        let /** @type {?} */ access_token = '';
        let /** @type {?} */ id_token = '';
        let /** @type {?} */ authResponseIsValid = false;
        let /** @type {?} */ decoded_id_token: any;

        this.getSigningKeys()
            .subscribe(jwtKeys => {
                this.jwtKeys = jwtKeys;

                if (!result.error) {

                    // validate state
                    if (this.oidcSecurityValidation.validateStateFromHashCallback(result.state, this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_auth_state_control))) {
                        if (this.authConfiguration.response_type === 'id_token token') {
                            access_token = result.access_token;
                        }
                        id_token = result.id_token;

                        let /** @type {?} */ headerDecoded;
                        decoded_id_token = this.oidcSecurityValidation.getPayloadFromToken(id_token, false);
                        headerDecoded = this.oidcSecurityValidation.getHeaderFromToken(id_token, false);

                        // validate jwt signature
                        if (this.oidcSecurityValidation.validate_signature_id_token(id_token, this.jwtKeys)) {
                            // validate nonce
                            if (this.oidcSecurityValidation.validate_id_token_nonce(decoded_id_token, this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_auth_nonce))) {
                                // validate required fields id_token
                                if (this.oidcSecurityValidation.validate_required_id_token(decoded_id_token)) {
                                    // validate max offset from the id_token issue to now
                                    if (this.oidcSecurityValidation.validate_id_token_iat_max_offset(decoded_id_token, this.authConfiguration.max_id_token_iat_offset_allowed_in_seconds)) {
                                        // validate iss
                                        if (this.oidcSecurityValidation.validate_id_token_iss(decoded_id_token, this.authWellKnownEndpoints.issuer)) {
                                            // validate aud
                                            if (this.oidcSecurityValidation.validate_id_token_aud(decoded_id_token, this.authConfiguration.client_id)) {
                                                // validate_id_token_exp_not_expired
                                                if (this.oidcSecurityValidation.validate_id_token_exp_not_expired(decoded_id_token)) {
                                                    // flow id_token token
                                                    if (this.authConfiguration.response_type === 'id_token token') {
                                                        // valiadate at_hash and access_token
                                                        if (this.oidcSecurityValidation.validate_id_token_at_hash(access_token, decoded_id_token.at_hash) || !access_token) {
                                                            authResponseIsValid = true;
                                                            this.successful_validation();
                                                        } else {
                                                            this.oidcSecurityCommon.logWarning('authorizedCallback incorrect at_hash');
                                                        }
                                                    } else {
                                                        authResponseIsValid = true;
                                                        this.successful_validation();
                                                    }
                                                } else {
                                                    this.oidcSecurityCommon.logWarning('authorizedCallback token expired');
                                                }
                                            } else {
                                                this.oidcSecurityCommon.logWarning('authorizedCallback incorrect aud');
                                            }
                                        } else {
                                            this.oidcSecurityCommon.logWarning('authorizedCallback incorrect iss does not match authWellKnownEndpoints issuer');
                                        }
                                    } else {
                                        this.oidcSecurityCommon.logWarning('authorizedCallback Validation, iat rejected id_token was issued too far away from the current time');
                                    }
                                } else {
                                    this.oidcSecurityCommon.logDebug('authorizedCallback Validation, one of the REQUIRED properties missing from id_token');
                                }
                            } else {
                                this.oidcSecurityCommon.logWarning('authorizedCallback incorrect nonce');
                            }
                        } else {
                            this.oidcSecurityCommon.logDebug('authorizedCallback Signature validation failed id_token');
                        }
                    } else {
                        this.oidcSecurityCommon.logWarning('authorizedCallback incorrect state');
                    }
                } else {
                    authResponseIsValid = true;
                    this.successful_validation();
                }

                if (authResponseIsValid) {
                    this.setAuthorizationData(access_token, id_token);
                    // flow id_token token
                    if (this.authConfiguration.response_type === 'id_token token') {
                        this.oidcSecurityUserService.initUserData()
                            .subscribe(() => {
                                this.oidcSecurityCommon.logDebug('authorizedCallback id_token token flow');
                                if (this.oidcSecurityValidation.validate_userdata_sub_id_token(decoded_id_token.sub, this.oidcSecurityUserService.userData.sub)) {
                                    this.onUserDataLoaded.emit();
                                    this.oidcSecurityCommon.logDebug(this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_access_token));
                                    this.oidcSecurityCommon.logDebug(this.oidcSecurityUserService.userData);
                                    if (this.authConfiguration.start_checksession) {
                                        this.oidcSecurityCheckSession.init().subscribe(() => {
                                            this.oidcSecurityCheckSession.pollServerSession(result.session_state, this.authConfiguration.client_id);
                                        });
                                    }

                                    if (this.authConfiguration.silent_renew) {
                                        this.oidcSecuritySilentRenew.initRenew();
                                    }

                                    this.runTokenValidatation();

                                    this.router.navigate([this.authConfiguration.startup_route]);
                                } else { // some went wrong, userdata sub does not match that from id_token
                                    this.oidcSecurityCommon.logWarning('authorizedCallback, User data sub does not match sub in id_token');
                                    this.oidcSecurityCommon.logDebug('authorizedCallback, token(s) validation failed, resetting');
                                    this.resetAuthorizationData();
                                    this.router.navigate([this.authConfiguration.unauthorized_route]);
                                }
                            });
                    } else { // flow id_token
                        this.oidcSecurityCommon.logDebug('authorizedCallback id_token flow');
                        this.oidcSecurityCommon.logDebug(this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_access_token));

                        // userData is set to the id_token decoded. No access_token.
                        this.oidcSecurityUserService.userData = decoded_id_token;
                        if (this.authConfiguration.start_checksession) {
                            this.oidcSecurityCheckSession.init().subscribe(() => {
                                this.oidcSecurityCheckSession.pollServerSession(result.session_state, this.authConfiguration.client_id);
                            });
                        }

                        if (this.authConfiguration.silent_renew) {
                            this.oidcSecuritySilentRenew.initRenew();
                        }

                        this.runTokenValidatation();
                        this.router.navigate([this.authConfiguration.startup_route]);
                    }
                } else { // some went wrong
                    this.oidcSecurityCommon.logDebug('authorizedCallback, token(s) validation failed, resetting');
                    this.resetAuthorizationData();
                    this.router.navigate([this.authConfiguration.unauthorized_route]);
                }
            }, error => {
                authResponseIsValid = true;
                this.successful_validation();

                if (authResponseIsValid) {
                    this.setAuthorizationData(access_token, id_token);
                    // flow id_token token
                    if (this.authConfiguration.response_type === 'id_token token') {
                        this.oidcSecurityUserService.initUserData()
                            .subscribe(() => {
                                this.oidcSecurityCommon.logDebug('authorizedCallback id_token token flow');
                                if (this.oidcSecurityValidation.validate_userdata_sub_id_token(decoded_id_token.sub, this.oidcSecurityUserService.userData.sub)) {
                                    this.onUserDataLoaded.emit();
                                    this.oidcSecurityCommon.logDebug(this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_access_token));
                                    this.oidcSecurityCommon.logDebug(this.oidcSecurityUserService.userData);
                                    if (this.authConfiguration.start_checksession) {
                                        this.oidcSecurityCheckSession.init().subscribe(() => {
                                            this.oidcSecurityCheckSession.pollServerSession(result.session_state, this.authConfiguration.client_id);
                                        });
                                    }

                                    if (this.authConfiguration.silent_renew) {
                                        this.oidcSecuritySilentRenew.initRenew();
                                    }

                                    this.runTokenValidatation();

                                    this.router.navigate([this.authConfiguration.startup_route]);
                                } else { // some went wrong, userdata sub does not match that from id_token
                                    this.oidcSecurityCommon.logWarning('authorizedCallback, User data sub does not match sub in id_token');
                                    this.oidcSecurityCommon.logDebug('authorizedCallback, token(s) validation failed, resetting');
                                    this.resetAuthorizationData();
                                    this.router.navigate([this.authConfiguration.unauthorized_route]);
                                }
                            });
                    } else { // flow id_token
                        this.oidcSecurityCommon.logDebug('authorizedCallback id_token flow');
                        this.oidcSecurityCommon.logDebug(this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_access_token));

                        // userData is set to the id_token decoded. No access_token.
                        this.oidcSecurityUserService.userData = decoded_id_token;
                        if (this.authConfiguration.start_checksession) {
                            this.oidcSecurityCheckSession.init().subscribe(() => {
                                this.oidcSecurityCheckSession.pollServerSession(result.session_state, this.authConfiguration.client_id);
                            });
                        }

                        if (this.authConfiguration.silent_renew) {
                            this.oidcSecuritySilentRenew.initRenew();
                        }

                        this.runTokenValidatation();
                        this.router.navigate([this.authConfiguration.startup_route]);
                    }
                } else { // some went wrong
                    this.oidcSecurityCommon.logDebug('authorizedCallback, token(s) validation failed, resetting');
                    this.resetAuthorizationData();
                    this.router.navigate([this.authConfiguration.unauthorized_route]);
                }
            });
    }
/**
 * @return {?}
 */
logoff() {
        // /connect/endsession?id_token_hint=...&post_logout_redirect_uri=https://myapp.com
        this.oidcSecurityCommon.logDebug('BEGIN Authorize, no auth data');

        if (this.authWellKnownEndpoints.end_session_endpoint) {
            let /** @type {?} */ authorizationEndsessionUrl = this.authWellKnownEndpoints.end_session_endpoint;

            let /** @type {?} */ id_token_hint = this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_id_token);
            let /** @type {?} */ post_logout_redirect_uri = this.authConfiguration.post_logout_redirect_uri;

            let /** @type {?} */ url =
                authorizationEndsessionUrl + '?' +
                'id_token_hint=' + encodeURI(id_token_hint) + '&' +
                'post_logout_redirect_uri=' + encodeURI(post_logout_redirect_uri);

            this.resetAuthorizationData();

            if (this.authConfiguration.start_checksession && this.checkSessionChanged) {
                this.oidcSecurityCommon.logDebug('only local login cleaned up, server session has changed');
            } else {
                window.location.href = url;
            }
        } else {
            this.resetAuthorizationData();
            this.oidcSecurityCommon.logDebug('only local login cleaned up, no end_session_endpoint');
        }
    }
/**
 * @return {?}
 */
private successful_validation() {
        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_auth_nonce, '');
        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_auth_state_control, '');
        this.oidcSecurityCommon.logDebug('AuthorizedCallback token(s) validated, continue');
    }
/**
 * @return {?}
 */
private refreshSession() {
        this.oidcSecurityCommon.logDebug('BEGIN refresh session Authorize');

        let /** @type {?} */ nonce = 'N' + Math.random() + '' + Date.now();
        let /** @type {?} */ state = Date.now() + '' + Math.random();

        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_auth_state_control, state);
        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_auth_nonce, nonce);
        this.oidcSecurityCommon.logDebug('RefreshSession created. adding myautostate: ' + this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_auth_state_control));

        let /** @type {?} */ url = this.createAuthorizeUrl(nonce, state);

        this.oidcSecuritySilentRenew.startRenew(url);
    }
/**
 * @param {?} access_token
 * @param {?} id_token
 * @return {?}
 */
private setAuthorizationData(access_token: any, id_token: any) {
        if (this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_access_token) !== '') {
            this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_access_token, '');
        }

        this.oidcSecurityCommon.logDebug(access_token);
        this.oidcSecurityCommon.logDebug(id_token);
        this.oidcSecurityCommon.logDebug('storing to storage, getting the roles');
        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_access_token, access_token);
        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_id_token, id_token);
        this.isAuthorized = true;
        this.oidcSecurityCommon.store(this.oidcSecurityCommon.storage_is_authorized, true);
    }
/**
 * @param {?} nonce
 * @param {?} state
 * @return {?}
 */
private createAuthorizeUrl(nonce: string, state: string): string {

        let /** @type {?} */ authorizationUrl = this.authWellKnownEndpoints.authorization_endpoint;
        let /** @type {?} */ client_id = this.authConfiguration.client_id;
        let /** @type {?} */ redirect_uri = this.authConfiguration.redirect_url;
        let /** @type {?} */ response_type = this.authConfiguration.response_type;
        let /** @type {?} */ scope = this.authConfiguration.scope;
        let /** @type {?} */ resource_identifier = this.authConfiguration.resource;

        //if default resource_identifier is not changed, do not include it
        if (resource_identifier != '') {
            resource_identifier = 'resource=' + encodeURI(this.authConfiguration.resource) + '&';
        }

        let /** @type {?} */ url =
            authorizationUrl + '?' +
            'response_type=' + encodeURI(response_type) + '&' +
            resource_identifier +
            'client_id=' + encodeURI(client_id) + '&' +
            'redirect_uri=' + encodeURI(redirect_uri) + '&' +
            'scope=' + encodeURI(scope) + '&' +
            'nonce=' + encodeURI(nonce) + '&' +
            'state=' + encodeURI(state);

        return url;

    }
/**
 * @return {?}
 */
private resetAuthorizationData() {
        this.isAuthorized = false;
        this.oidcSecurityCommon.resetStorageData();
        this.checkSessionChanged = false;
    }
/**
 * @param {?} error
 * @return {?}
 */
handleError(error: any) {
        this.oidcSecurityCommon.logError(error);
        if (error.status == 403) {
            this.router.navigate([this.authConfiguration.forbidden_route]);
        } else if (error.status == 401) {
            this.resetAuthorizationData();
            this.router.navigate([this.authConfiguration.unauthorized_route]);
        }
    }
/**
 * @return {?}
 */
private onCheckSessionChanged() {
        this.oidcSecurityCommon.logDebug('onCheckSessionChanged');
        this.checkSessionChanged = true;
    }
/**
 * @return {?}
 */
private runGetSigningKeys() {
        this.getSigningKeys()
            .subscribe(
            jwtKeys => this.jwtKeys = jwtKeys,
            error => this.errorMessage = /** @type {?} */(( <any>error)));
    }
/**
 * @return {?}
 */
private getSigningKeys(): Observable<JwtKeys> {
        this.oidcSecurityCommon.logDebug('jwks_uri: ' + this.authWellKnownEndpoints.jwks_uri);
        return this.http.get(this.authWellKnownEndpoints.jwks_uri)
            .map(this.extractData)
            .catch(this.handleErrorGetSigningKeys);
    }
/**
 * @param {?} res
 * @return {?}
 */
private extractData(res: Response) {
        let /** @type {?} */ body = res.json();
        return body;
    }
/**
 * @param {?} error
 * @return {?}
 */
private handleErrorGetSigningKeys(error: Response | any) {
        let /** @type {?} */ errMsg: string;
        if (error instanceof Response) {
            const /** @type {?} */ body = error.json() || '';
            const /** @type {?} */ err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
/**
 * @return {?}
 */
private runTokenValidatation() {
        let /** @type {?} */ source = Observable.timer(3000, 3000)
            .timeInterval()
            .pluck('interval')
            .take(10000);

        let /** @type {?} */ subscription = source.subscribe(() => {
            if (this.isAuthorized) {
                if (this.oidcSecurityValidation.isTokenExpired(this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_id_token))) {
                    this.oidcSecurityCommon.logDebug('IsAuthorized: id_token isTokenExpired, start silent renew if active');

                    if (this.authConfiguration.silent_renew) {
                        this.refreshSession();
                    } else {
                        this.resetAuthorizationData();
                    }
                }
            }
        },
            (err: any) => {
                this.oidcSecurityCommon.logError('Error: ' + err);
            },
            () => {
                this.oidcSecurityCommon.logDebug('Completed');
            });
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: AuthConfiguration, },
{type: Router, },
{type: OidcSecurityCheckSession, },
{type: OidcSecuritySilentRenew, },
{type: OidcSecurityUserService, },
{type: OidcSecurityCommon, },
{type: AuthWellKnownEndpoints, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onUserDataLoaded': [{ type: Output },],
};
}

function OidcSecurityService_tsickle_Closure_declarations() {
/** @type {?} */
OidcSecurityService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OidcSecurityService.ctorParameters;
/** @type {?} */
OidcSecurityService.propDecorators;
/** @type {?} */
OidcSecurityService.prototype.onUserDataLoaded;
/** @type {?} */
OidcSecurityService.prototype.checkSessionChanged;
/** @type {?} */
OidcSecurityService.prototype.isAuthorized;
/** @type {?} */
OidcSecurityService.prototype.headers;
/** @type {?} */
OidcSecurityService.prototype.oidcSecurityValidation;
/** @type {?} */
OidcSecurityService.prototype.errorMessage;
/** @type {?} */
OidcSecurityService.prototype.jwtKeys;
/** @type {?} */
OidcSecurityService.prototype.http;
/** @type {?} */
OidcSecurityService.prototype.authConfiguration;
/** @type {?} */
OidcSecurityService.prototype.router;
/** @type {?} */
OidcSecurityService.prototype.oidcSecurityCheckSession;
/** @type {?} */
OidcSecurityService.prototype.oidcSecuritySilentRenew;
/** @type {?} */
OidcSecurityService.prototype.oidcSecurityUserService;
/** @type {?} */
OidcSecurityService.prototype.oidcSecurityCommon;
/** @type {?} */
OidcSecurityService.prototype.authWellKnownEndpoints;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
